import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { DeviceRemove } from '.';
import { deleteItem, editItem } from '../../fetch';
import { devicesActions } from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import DeviceLinkedGeofence from './DeviceLinkedGeofence';
import {
  selectDevicesArray,
  selectGroupSelectedId,
  selectPositionsArray,
  selectSession
} from '../../createSelectorUtils';
// ----------------------------------------------------------------------

DeviceMoreMenu.propTypes = {
  id: PropTypes.number.isRequired
};

export default function DeviceMoreMenu({ id }) {
  const t = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const session = useSelector(selectSession);
  const groupId = useSelector(selectGroupSelectedId);
  const permission = session.permission
    ? session.permission.find((item) => item.groupid === groupId) || {}
    : {};

  const position = useSelector(selectPositionsArray).find((position) => position.deviceId === id);

  const device = useSelector(selectDevicesArray).find((item) => item.id === id);

  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);

  const handleDelete = async () => {
    const response = await deleteItem('devices', id);
    if (response.ok) {
      enqueueSnackbar(t('DL_Snackbar_Delete'), { variant: 'success' });
      dispatch(devicesActions.delete(id));
      setIsOpen(false);
    } else {
      const error = await response.text();
      const message = error.slice(0, error.indexOf('-'));
      enqueueSnackbar(message, { variant: 'error' });
    }
    setOpenRemove(false);
  };

  const handleSatellite = () => {
    if (position && position.attributes && position.attributes.sat) {
      enqueueSnackbar(`${t('DL_Snackbar_Satellite')} ${position.attributes.sat}`, {
        variant: 'info'
      });
    } else {
      enqueueSnackbar(t('DL_Snackbar_Satellite_Error'), {
        variant: 'error'
      });
    }
  };

  const handleCorrectionAnalyse = async () => {
    const response = await editItem('correction/volAndAnalyse', undefined, id);
    if (response.ok) {
      enqueueSnackbar(t('DL_Snackbar_Correction_Vol_Analyse'), {
        variant: 'success'
      });
    } else {
      const error = await response.text();
      const message = error.slice(0, error.indexOf('-'));
      enqueueSnackbar(message, { variant: 'error' });
    }
  };
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => navigate('edit', { state: { id } })}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary={t('btn_Edit')} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {(session.administrator || (groupId === 0 && device.groupId === 0)) && (
          <MenuItem sx={{ color: 'text.secondary' }} onClick={() => setOpenRemove(true)}>
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary={t('btn_Delete')} primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {(session.administrator ||
          groupId === 0 ||
          permission.status === 0 ||
          permission.status === 1) && <DeviceLinkedGeofence deviceId={id} />}

        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleSatellite}>
          <ListItemIcon>
            <Icon icon="gis:satellite" width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary={t('DL_Satellite_btn')}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
        {session.administrator && (
          <MenuItem sx={{ color: 'text.secondary' }} onClick={handleCorrectionAnalyse}>
            <ListItemIcon>
              <Icon icon="ic:baseline-autorenew" width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary={t('DL_Correction_Vol_Analyse_btn')}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        )}
      </Menu>
      <DeviceRemove
        open={openRemove}
        handleClose={() => setOpenRemove(false)}
        handleDelete={handleDelete}
      />
    </>
  );
}
